import React from 'react';
import Select from 'react-select';
import flags from 'react-phone-number-input/flags';
import { Countries } from './public/Home/CountryFlag';

const CountrySelect = ({ value, onChange, labels, classes, readOnly, ...rest }) => {
    const countries = Countries.map((countryCode) => ({
        value: countryCode.code,
        label: <div>
            <img
                src={countryCode.file_url}
                alt={`Flag of ${countryCode.code}`}
                className="w-6 h-6"
            />
        </div>
    }));

    const handleChange = (selectedOption) => {
        onChange(selectedOption.value);
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            border: 'none',
            boxShadow: 'none',
            padding: '0',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            height: "40px",
            padding: '0 6px',
            borderRadius: '8px',
            border: 'none'
        }),
        menu: (base) => ({
            ...base,
            border: 'none',
            width: '300px',
            textAlign: 'left',
            maxWidth: 400,
            overflow: 'auto',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
    };

    return (
        <Select
            value={countries.find(option => option.value === value)}
            onChange={handleChange}
            options={countries}
            styles={customStyles}
            isDisabled={readOnly}
            {...rest}
        />
    );
};

export default CountrySelect;
